<template>
  <div>
    <div class="totalnav">
      <div class="totalnav-center">
        <div class="item">
          <div class="icon gongying"><i></i></div>
          <div class="text">
            <div>采购人</div>
            <div class="num">{{ total.cgtotal?total.cgtotal:' ' }}</div>
          </div>
          <div class="line"></div>
        </div>
        <div class="item">
          <div class="icon caigouren"><i></i></div>
          <div class="text">
            <div>供应商</div>
            <div class="num">{{ total.gystotal?total.gystotal:' ' }}</div>
          </div>
        </div>
        <div class="item">
          <div class="icon histogram"><i></i></div>
          <div class="text">
            <div>访问量</div>
            <div class="num">{{ total.cosvisittotal?total.cosvisittotal:' ' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
export default {
  name: "NumScroll",
  data() {
    return {
      total: {
        cgtotal: 0,
        gystotal: 0,
        cosvisittotal: 0,
      },
    };
  },
  created() {
    this.getWebTotal();
  },
  methods: {
    numScroll(totalName, val, delay) {
      let numIsInt = this.isInt(val);
      let numIsFloat = this.isFloat(val);
      let step = (val / 1500) * 10;
      let num = 0
      setTimeout(() => {
        let time = setInterval(() => {
          if (numIsInt) {
            this.total[totalName]  = Math.floor(num)
          } else if (numIsFloat != -1) {
            this.total[totalName] = num.toFixed(numIsFloat)
          } else {
            this.total[totalName] = val
            clearInterval(time);
            return;
          }
          num += step;
          if (this.total[totalName] >= val) {
            this.total[totalName] = val;
            clearInterval(time);
          }
        }, delay);
      }, 1000);
    },
    async getWebTotal() {
      let res = await request({
        method: "get",
        url: "/web/web/getWebTotal",
        params: { cosid: this.cosId },
      });
      if (res) {
        this.numScroll("cgtotal", res.cgtotal, 0);
        this.numScroll("gystotal", res.gystotal, 0);
        this.numScroll("cosvisittotal", res.cosvisittotal, 0);
      }
    },
    isInt(num) {
      var res = false;
      try {
        if (String(num).indexOf(".") == -1 && String(num).indexOf(",") == -1) {
          res = parseInt(num) % 1 === 0 ? true : false;
        }
      } catch (e) {
        res = false;
      }
      return res;
    },
    isFloat(num) {
      var res = -1;
      try {
        if (String(num).indexOf(".") != -1) {
          var index = String(num).indexOf(".") + 1; //获取小数点的位置
          var count = String(num).length - index; //获取小数点后的个数
          if (index > 0) {
            res = count;
          }
        }
      } catch (e) {
        res = -1;
      }
      return res;
    },
  },
  computed: {
    ...mapGetters(["cosId"]),
  },
};
</script>


<style lang="scss" scoped>
@import "../../styles/variables.scss";
@media screen and (min-width: 769px) {
.totalnav {
  display: flex;
  align-items: center;
  height: 100px;
  background-color: $color-bg-white;

  .totalnav-center {
    /*background-color: #42b983;*/
    flex-grow: 2;
    /*width: 100%;*/
    display: flex;
    justify-content: center;
    align-items: center;

    .item {
      width: 17%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #e6e6e6;
      &:last-child {
        border-right: 0;
      }
      .icon {
        background-color: $color-orange;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          display: block;
          width: 30px;
          height: 30px;
          background-size: 30px 30px;
        }
      }
      .caigouren {
        i {
          background-image: url("../../assets/img/icon_caigouren.png");
        }
      }
      .histogram {
        i {
          background-image: url("../../assets/img/histogram.png");
        }
      }
      .gongying {
        i {
          background-image: url("../../assets/img/icon_gongyingshang.png");
        }
      }
      .zhuanjia {
        i {
          background-image: url("../../assets/img/icon_zhuanjia.png");
        }
      }
      .xiangmu {
        i {
          background-image: url("../../assets/img/icon_leijixiangmu.png");
        }
      }
      .text {
        padding-left: 20px;
        display: flex;
        font-size: $fontsize-large-x;
        font-weight: bold;
        flex-direction: column;
        line-height: 22px;
        .num {
          text-align: center;
          color: $color-orange;
        }
      }
    }
  }
}
}
@media screen and (max-width: 768px) {
    .totalnav {
      .totalnav-center {
        display: flex;
        justify-content: space-around;
        .item {
          margin: 10px 0;
          padding-right: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid #e6e6e6;
          &:last-child {
            border-right: 0;
          }
          .icon {
            background-color: $color-orange;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            i {
              display: block;
              width: 15px;
              height: 15px;
              background-size: 15px 15px;
            }
          }
          .caigouren {
            i {
              background-image: url("../../assets/img/icon_caigouren.png");
            }
          }
          .gongying {
            i {
              background-image: url("../../assets/img/icon_gongyingshang.png");
            }
          }
          .histogram {
            i {
              background-image: url("../../assets/img/histogram.png");
            }
          }
          .zhuanjia {
            i {
              background-image: url("../../assets/img/icon_zhuanjia.png");
            }
          }
          .xiangmu {
            i {
              background-image: url("../../assets/img/icon_leijixiangmu.png");
            }
          }
          .text {
            padding-left: 10px;
            display: flex;
            font-size: $fontsize-small;
            font-weight: bold;
            flex-direction: column;
            line-height: 20px;
            .num {
              text-align: center;
              color: $color-orange;
            }
          }
        }
      }
    }
}
</style>
